import { heartsDescriptor } from '@cardforest/games/games/hearts/descriptor.js';
import { CardVignette, MiniPlayingCard, SuitGlyph } from '../discovery/cards.js';
import type { GameDiscoveryPresentation } from '../discovery/types.js';

export const heartsDiscoveryPresentation = {
  gameId: heartsDescriptor.gameId,
  Icon: ({ className }) => <SuitGlyph suit="hearts" className={className} />,
  Thumbnail: () => (
    <CardVignette>
      <MiniPlayingCard rank="A" suit="hearts" className="-rotate-8 -translate-x-2 translate-y-0.5" />
      <MiniPlayingCard rank="Q" suit="spades" className="z-10 rotate-8 translate-x-2 -translate-y-0.5" />
    </CardVignette>
  ),
} satisfies GameDiscoveryPresentation;
